import type { ErrorMap } from '@/app/error-registry';

export const TAGS_ERROR_MAP: ErrorMap = {
  POST: {
    'Tag.NameAlreadyExists': 'tags:apiErrors.nameAlreadyExists',
    'Tag.InvalidColor': 'tags:apiErrors.invalidColor',
    'Tag.EmptyName': 'tags:apiErrors.emptyName',
    'Tag.NameTooLong': 'tags:apiErrors.nameTooLong',
    default: 'tags:apiErrors.createDefault',
  },
  PUT: {
    'Tag.NotFound': 'tags:apiErrors.notFound',
    'Tag.NameAlreadyExists': 'tags:apiErrors.nameAlreadyExists',
    'Tag.InvalidColor': 'tags:apiErrors.invalidColor',
    'Tag.EmptyName': 'tags:apiErrors.emptyName',
    'Tag.NameTooLong': 'tags:apiErrors.nameTooLong',
    default: 'tags:apiErrors.updateDefault',
  },
  DELETE: {
    'Tag.NotFound': 'tags:apiErrors.notFound',
    default: 'tags:apiErrors.deleteDefault',
  },
};
